module.exports = __webpack_public_path__ + "img/ico-scroll.2dcd1b21.svg";